import {useGetThresholdInfoQuery} from "../../../redux/api/alertSource";

export default function AlertSourceUnit({alertSourceUuid}: {alertSourceUuid: string}) {

  const {data: thresholdInfo} = useGetThresholdInfoQuery({alertSourceUuid})
  return <>{thresholdInfo?.unit || ""}</>
}